"use client";

import { useRouter } from "next/navigation";

import { CheckboxFacet } from "./checkbox-facet";
import { buildItemSearchUrl, type ItemSearchParams } from "@/lib/item-search-params";
import type { FacetCount } from "./types";

export function ConditionFacet({
  facets,
  params,
}: {
  facets: FacetCount[];
  params: ItemSearchParams;
}) {
  const router = useRouter();

  return (
    <CheckboxFacet
      title="Condition"
      facets={facets}
      selected={params.condition}
      onChange={(next) => router.push(buildItemSearchUrl(params, { condition: next }))}
      searchThreshold={9999}
    />
  );
}
